(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) {
        return;
      }

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (
        scrollTop <= this.headerBounds.top
      ) {
        this.header.classList.remove('scrolled-past-header');

        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.closeAccountMenu();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) =>
        disclosure.close()
      );
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal ||
        this.header.querySelector('details-modal');

      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }

    closeAccountMenu() {
      const accountDialog = this.header.querySelector('[data-cbm-student-login-modal]');
      if (accountDialog?.open) accountDialog.close();
    }
  }

  customElements.define(
    'sticky-header',
    StickyHeader
  );

  function initCbmStudentLoginModal() {
    document.querySelectorAll('[data-cbm-student-login-modal]').forEach((dialog) => {
      if (dialog.dataset.cbmStudentLoginReady === 'true') return;
      dialog.dataset.cbmStudentLoginReady = 'true';

      const trigger = document.querySelector(`[aria-controls="${dialog.id}"][data-cbm-student-login-open]`);
      const closeButton = dialog.querySelector('[data-cbm-student-login-close]');
      const helpButton = dialog.querySelector('[data-cbm-student-login-help]');
      const backButton = dialog.querySelector('[data-cbm-student-login-back]');
      const contactSupportButton = dialog.querySelector('[data-cbm-student-login-contact-support]');
      const supportBackButton = dialog.querySelector('[data-cbm-student-support-back]');
      const doneButton = dialog.querySelector('[data-cbm-student-login-done]');
      const portalStep = dialog.querySelector('[data-cbm-student-login-step="portal"]');
      const helpStep = dialog.querySelector('[data-cbm-student-login-step="help"]');
      const supportFormStep = dialog.querySelector('[data-cbm-student-login-step="support-form"]');
      const successStep = dialog.querySelector('[data-cbm-student-login-step="success"]');
      const helpHeading = dialog.querySelector('[data-cbm-student-login-help-heading]');
      const supportHeading = dialog.querySelector('[data-cbm-student-support-heading]');
      const successHeading = dialog.querySelector('[data-cbm-student-support-success-heading]');
      const supportForm = dialog.querySelector('.cbm-student-login-modal__form');
      const supportSubmissionKey = 'cbmOlderCourseSupportSubmittedAt';

      const hideAllSteps = () => {
        [portalStep, helpStep, supportFormStep, successStep].forEach((step) => {
          if (step) step.hidden = true;
        });
      };

      const showPortalStep = () => {
        hideAllSteps();
        if (portalStep) portalStep.hidden = false;
      };

      const showHelpStep = () => {
        hideAllSteps();
        if (helpStep) helpStep.hidden = false;
      };

      const showSupportFormStep = () => {
        hideAllSteps();
        if (supportFormStep) supportFormStep.hidden = false;
      };

      const showSuccessStep = () => {
        hideAllSteps();
        if (successStep) successStep.hidden = false;
      };

      trigger?.addEventListener('click', () => {
        showPortalStep();
        dialog.showModal();
        requestAnimationFrame(() => closeButton?.focus());
      });

      closeButton?.addEventListener('click', () => dialog.close());
      doneButton?.addEventListener('click', () => dialog.close());

      helpButton?.addEventListener('click', () => {
        showHelpStep();
        requestAnimationFrame(() => helpHeading?.focus());
      });

      backButton?.addEventListener('click', () => {
        showPortalStep();
        requestAnimationFrame(() => helpButton?.focus());
      });

      contactSupportButton?.addEventListener('click', () => {
        showSupportFormStep();
        requestAnimationFrame(() => supportHeading?.focus());
      });

      supportBackButton?.addEventListener('click', () => {
        showHelpStep();
        requestAnimationFrame(() => contactSupportButton?.focus());
      });

      supportForm?.addEventListener('submit', () => {
        try {
          sessionStorage.setItem(supportSubmissionKey, String(Date.now()));
        } catch (error) {
          // Submission still works if sessionStorage is unavailable.
        }
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', () => {
        showPortalStep();
        trigger?.focus();
      });

      try {
        const submittedAt = Number(sessionStorage.getItem(supportSubmissionKey) || 0);
        const isRecentSubmission = submittedAt > 0 && Date.now() - submittedAt < 5 * 60 * 1000;

        if (isRecentSubmission) {
          sessionStorage.removeItem(supportSubmissionKey);
          showSuccessStep();
          dialog.showModal();
          requestAnimationFrame(() => successHeading?.focus());
        } else if (submittedAt) {
          sessionStorage.removeItem(supportSubmissionKey);
        }
      } catch (error) {
        // No-op when sessionStorage is unavailable.
      }
    });
  }

  initCbmStudentLoginModal();
  document.addEventListener('shopify:section:load', initCbmStudentLoginModal);

  function initCbmStickyDesktopNav() {
    const sectionHeader = document.querySelector('.section-header');
    const nav = sectionHeader?.querySelector('.header__inline-menu');

    if (!sectionHeader || !nav || sectionHeader.dataset.cbmStickyNavReady === 'true') return;

    const stickyNavDisabled =
      sectionHeader.querySelector('.header-wrapper')?.dataset.cbmDisableStickyNav === 'true';

    if (stickyNavDisabled) {
      sectionHeader.classList.remove('cbm-nav-sticky-active');
      sectionHeader.style.removeProperty('--cbm-sticky-nav-height');
      sectionHeader.style.removeProperty('--cbm-sticky-nav-left');
      sectionHeader.style.removeProperty('--cbm-sticky-nav-width');
      sectionHeader.dataset.cbmStickyNavReady = 'disabled';
      return;
    }

    sectionHeader.dataset.cbmStickyNavReady = 'true';

    const desktopQuery = window.matchMedia('(min-width: 990px)');
    let navStart = 0;
    let ticking = false;

    const deactivate = () => {
      sectionHeader.classList.remove('cbm-nav-sticky-active');
    };

    const measure = () => {
      deactivate();

      if (!desktopQuery.matches) {
        sectionHeader.style.removeProperty('--cbm-sticky-nav-height');
        sectionHeader.style.removeProperty('--cbm-sticky-nav-left');
        sectionHeader.style.removeProperty('--cbm-sticky-nav-width');
        return;
      }

      const rect = nav.getBoundingClientRect();
      navStart = rect.top + window.scrollY;

      sectionHeader.style.setProperty('--cbm-sticky-nav-height', `${rect.height}px`);
      sectionHeader.style.setProperty('--cbm-sticky-nav-left', `${rect.left}px`);
      sectionHeader.style.setProperty('--cbm-sticky-nav-width', `${rect.width}px`);

      update();
    };

    const getAnnouncementHeight = () => {
      const styles = getComputedStyle(document.documentElement);
      const announcementValue = styles.getPropertyValue('--cbm-announcement-height');
      return parseFloat(announcementValue) || 0;
    };

    const update = () => {
      if (!desktopQuery.matches) {
        deactivate();
        return;
      }

      const activationPoint = Math.max(0, navStart - getAnnouncementHeight());
      sectionHeader.classList.toggle('cbm-nav-sticky-active', window.scrollY >= activationPoint);
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
    document.addEventListener('cbm:announcement-height-change', measure);
    desktopQuery.addEventListener('change', measure);

    if (document.fonts?.ready) {
      document.fonts.ready.then(measure);
    } else {
      measure();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCbmStickyDesktopNav, { once: true });
  } else {
    initCbmStickyDesktopNav();
  }

  document.addEventListener('shopify:section:load', initCbmStickyDesktopNav);

  function initCbmPhase2HoverMenus(root = document) {
    const desktopHoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const navs = root.querySelectorAll ? root.querySelectorAll('.cbm-header-phase2 .cbm-phase2-nav') : [];

    navs.forEach((nav) => {
      if (nav.dataset.cbmHoverMenusReady === 'true') return;
      nav.dataset.cbmHoverMenusReady = 'true';

      const detailsItems = Array.from(nav.querySelectorAll('.cbm-phase2-nav__details'));
      const closeTimers = new WeakMap();

      const clearCloseTimer = (details) => {
        const timer = closeTimers.get(details);
        if (timer) {
          window.clearTimeout(timer);
          closeTimers.delete(details);
        }
      };

      const finishClose = (details) => {
        clearCloseTimer(details);
        details.open = false;
        details.classList.remove('is-opening', 'is-closing');
      };

      const closeMenu = (details, options = {}) => {
        const { force = false, grace = 90 } = options;
        clearCloseTimer(details);

        if (!details.open) {
          details.classList.remove('is-opening', 'is-closing');
          return;
        }

        if (!force && details.matches(':focus-within')) return;

        const beginClose = () => {
          if (!force && (details.matches(':hover') || details.matches(':focus-within'))) return;

          if (reducedMotionQuery.matches) {
            finishClose(details);
            return;
          }

          details.classList.remove('is-opening');
          details.classList.add('is-closing');

          const animationTimer = window.setTimeout(() => finishClose(details), 220);
          closeTimers.set(details, animationTimer);
        };

        if (grace > 0) {
          const graceTimer = window.setTimeout(beginClose, grace);
          closeTimers.set(details, graceTimer);
        } else {
          beginClose();
        }
      };

      const openMenu = (details) => {
        clearCloseTimer(details);
        details.classList.remove('is-closing');

        detailsItems.forEach((otherDetails) => {
          if (otherDetails !== details && otherDetails.open) {
            closeMenu(otherDetails, { force: true, grace: 0 });
          }
        });

        if (details.open) return;

        details.open = true;

        if (reducedMotionQuery.matches) return;

        details.classList.add('is-opening');
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            details.classList.remove('is-opening');
          });
        });
      };

      detailsItems.forEach((details) => {
        const summary = details.querySelector(':scope > summary');

        details.addEventListener('pointerenter', () => {
          if (!desktopHoverQuery.matches) return;
          openMenu(details);
        });

        details.addEventListener('pointerleave', () => {
          if (!desktopHoverQuery.matches) return;
          closeMenu(details);
        });

        details.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !details.open) return;

          event.preventDefault();
          closeMenu(details, { force: true, grace: 0 });
          if (summary) summary.focus();
        });

        details.addEventListener('focusout', () => {
          window.requestAnimationFrame(() => {
            if (!details.matches(':focus-within') && !details.matches(':hover')) {
              closeMenu(details, { grace: 0 });
            }
          });
        });
      });

      desktopHoverQuery.addEventListener('change', (event) => {
        if (event.matches) return;
        detailsItems.forEach((details) => finishClose(details));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCbmPhase2HoverMenus(), { once: true });
  } else {
    initCbmPhase2HoverMenus();
  }

  document.addEventListener('shopify:section:load', (event) => initCbmPhase2HoverMenus(event.target));

  } catch(e) { console.error(e); }
})();
})();
